<template>
  <div class="mt-20 flex items-center justify-center">
    <div class="spinner-border inline-block h-8 w-8 animate-spin rounded-full border-4 text-primary-500" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>
